/** Official app store listing URLs (single source for Home, footer, etc.) */
export const APP_STORE_URL = 'https://apps.apple.com/app/mindful-family';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.webviewgold.mindfulfamily&pcampaignid=web_share';
